/**
 * Defer non-critical CSS loading to improve First Contentful Paint (FCP)
 * This plugin loads CSS files after the page has rendered, reducing render-blocking resources
 */
export default defineNuxtPlugin(() => {
  if (import.meta.server) {
    return
  }

  // Defer loading of non-critical CSS after page load
  // This improves FCP and LCP metrics
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferNonCriticalCSS)
  } else {
    deferNonCriticalCSS()
  }

  function deferNonCriticalCSS() {
    // Use requestIdleCallback if available, otherwise setTimeout
    const defer = window.requestIdleCallback || ((fn: () => void) => setTimeout(fn, 1))
    
    defer(() => {
      // Find all stylesheet links that aren't already loaded
      const stylesheets = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'))
      
      // Defer stylesheets that are not critical (e.g., SurveyJS styles)
      // Critical styles (Tailwind, main.css) should already be loaded
      stylesheets.forEach((link) => {
        const href = link.href
        // Defer SurveyJS CSS if present (loaded dynamically)
        if (href.includes('survey') || href.includes('defaultV2')) {
          // These are already loaded on-demand, so skip
          return
        }
        
        // For other non-critical stylesheets, we could defer them here
        // But most should already be code-split by Vite
      })
    })
  }
})
